import type { ApolloCache, NormalizedCacheObject } from '@apollo/client';
import { InMemoryCache } from '@apollo/client';

import { dataIdFromObject } from './dataIdFromObject';
import { getTypePolicies } from './typePolicies';

export function getApolloCache(): ApolloCache<NormalizedCacheObject> {
  const typePolicies = getTypePolicies();

  return new InMemoryCache({ dataIdFromObject, typePolicies });
}
